import React, { useContext } from 'react'
import { Link } from 'react-router-dom';
import './Nav.scss'
import scholasticLogo from 'images/scholastic-logo-white-outline.svg'
import bookWizardLogoMobile from 'images/bw-logo-white-mobile.svg'
import bookWizardLogoDesktop from 'images/bw-logo-white-desktop.svg'
import { ConfigContext } from 'providers/ConfigContext';
import Profile from 'components/content/Profile/Profile.js';
import Cart from 'components/content/Cart/Cart.js';

export default function Nav(props) {
	const configContext = useContext(ConfigContext);

	let tsoOrigin = configContext.tso.origin;
	let isMobile = window.matchMedia('(max-width: 719px)').matches;
	let scrollTopNav = isMobile ? '0px' : '-94px';
	return (
		<nav className={`globalnav ${props.hideOnScroll ? '' : 'scroll-up'}`} style={{top: `${props.hideOnScroll ? '' : scrollTopNav}`}}>
			<a className="globalnav__scholastic" href={tsoOrigin + "/teachers-ecommerce/teacher/tsohomepage.html"}>
					<img src={scholasticLogo} className="globalnav__scholastic-logo" alt="Scholastic Logo" tabIndex="0"/>
			</a>
			<div className="globalnav__book-wizard">
				<Link to="/" className="globalnav__book-wizard-logo">
					<img src={bookWizardLogoMobile} srcSet={`${bookWizardLogoDesktop} 720w`} alt="Book Wizard Logo" tabIndex="0"/>
				</Link>
				<Profile 
					isSignedIn={props.isSignedIn}
					myScholasticModal={props.myScholasticModal}
					setMyScholasticModal={props.setMyScholasticModal} 
					onSignInChange={props.setIsSignedIn}/>
				<Cart 
					isSignedIn={props.isSignedIn} 
					setMyScholasticModal={props.setMyScholasticModal}
					addToCartItem={props.addToCartItem}
					hideOnScroll={props.hideOnScroll} />
			</div>
		</nav>
	)
}